export enum Phase {
  DancerSelection,
  SchoolSelection,
  PublishResults,
}
